import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlighter'
})
export class HighlightSearchPipe implements PipeTransform {

  transform(value: any, args: any,type:string): unknown {
    if(!args) return value;
    args = args.replace(/[\\\/]+/g, '')
    if(args.includes('(') && !args.includes(')')) args = args.replace(/[\(\)]+/g, '')
    
    if(type==='full'){
      const re = new RegExp("\\b("+args+"\\b)", 'igm');
      value= value.replace(re, '<span class="highlighted-text-gs">$1</span>');
    }
    else{
      const re = new RegExp(args, 'igm');
      value= value.replace(re, '<span class="highlighted-text-gs">$&</span>');
      if((/^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/).test(value) && (/^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/).test(args) && value.includes(args)){
        value = `<span class="highlighted-text-gs">${args}</span>`
      }
    }

    return value;
  }

}